export const version = "logger/5.7.0";
